// Schema.org structured data generators for SEO

export const generateOrganizationSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "HealthAndBeautyBusiness",
    "name": "Lyfe Simply",
    "description": "Professional hypnotherapy, life coaching, and training services in Dubai",
    "url": "https://therapy-booking-cms.preview.emergentagent.com",
    "logo": "https://images.unsplash.com/photo-1528715471579-d1bcf0ba5e83?w=200&h=200&fit=crop",
    "image": "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1200&h=630&fit=crop",
    "telephone": "+971 50 525 0093",
    "email": "admin@lyfesimply.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Dubai",
      "addressCountry": "AE"
    },
    "openingHours": "Mo-Sa 09:00-18:00",
    "priceRange": "AED 400 - AED 12000",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "500",
      "bestRating": "5",
      "worstRating": "1"
    },
    "founder": {
      "@type": "Person",
      "name": "Jacky",
      "jobTitle": "Clinical Hypnotherapist & Life Coach",
      "description": "Certified therapist and trainer with 15+ years of experience"
    },
    "sameAs": [
      "https://www.instagram.com/lyfesimply",
      "https://www.youtube.com/lyfesimply",
      "https://www.facebook.com/lyfesimply"
    ]
  };
};

export const generatePersonSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Jacky",
    "jobTitle": "Clinical Hypnotherapist, Life Coach & Trainer",
    "description": "Certified therapist and trainer with 15+ years of experience in hypnotherapy, life coaching, and transformative practices",
    "image": "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&h=700&fit=crop",
    "url": "https://therapy-booking-cms.preview.emergentagent.com",
    "worksFor": {
      "@type": "Organization",
      "name": "Lyfe Simply"
    },
    "alumniOf": "University of Bradford",
    "hasCredential": [
      {
        "@type": "EducationalOccupationalCredential",
        "credentialCategory": "degree",
        "name": "B.E (Hons) Electrical and Electronic Engineering"
      },
      {
        "@type": "EducationalOccupationalCredential",
        "credentialCategory": "degree",
        "name": "MBA"
      }
    ]
  };
};

export const generateServiceSchema = (service) => {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": service.title,
    "name": service.title,
    "description": service.description,
    "provider": {
      "@type": "Organization",
      "name": "Lyfe Simply"
    },
    "areaServed": {
      "@type": "City",
      "name": "Dubai"
    },
    "offers": {
      "@type": "Offer",
      "price": service.price,
      "priceCurrency": "AED"
    }
  };
};

export const generateCourseSchema = (course) => {
  return {
    "@context": "https://schema.org",
    "@type": "Course",
    "name": course.title,
    "description": course.description,
    "provider": {
      "@type": "Organization",
      "name": "Lyfe Simply"
    },
    "offers": {
      "@type": "Offer",
      "price": course.price,
      "priceCurrency": "AED"
    },
    "hasCourseInstance": {
      "@type": "CourseInstance",
      "courseMode": "blended",
      "duration": course.duration
    },
    "teaches": course.syllabus
  };
};

export const generateEventSchema = (event) => {
  return {
    "@context": "https://schema.org",
    "@type": "Event",
    "name": event.title,
    "description": event.description,
    "startDate": event.date,
    "eventAttendanceMode": "https://schema.org/MixedEventAttendanceMode",
    "eventStatus": "https://schema.org/EventScheduled",
    "location": {
      "@type": "Place",
      "name": "Lyfe Simply",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Dubai",
        "addressCountry": "AE"
      }
    },
    "image": event.image,
    "offers": {
      "@type": "Offer",
      "price": event.price,
      "priceCurrency": "AED",
      "availability": "https://schema.org/InStock"
    },
    "organizer": {
      "@type": "Organization",
      "name": "Lyfe Simply",
      "url": "https://therapy-booking-cms.preview.emergentagent.com"
    }
  };
};

export const generateReviewSchema = (review) => {
  return {
    "@context": "https://schema.org",
    "@type": "Review",
    "author": {
      "@type": "Person",
      "name": review.name
    },
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": review.rating,
      "bestRating": "5",
      "worstRating": "1"
    },
    "reviewBody": review.comment,
    "datePublished": review.date
  };
};

export const generateBreadcrumbSchema = (items) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };
};
